package com.findyourbuddies.website.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.findyourbuddies.website.data.legal.ApiClient
import com.findyourbuddies.website.data.legal.LegalApi
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import markdown.Marked
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Div

@Page
@Composable
fun TermsOfServicePage() {
    val api = remember {
        LegalApi(ApiClient.httpClient)
    }

    var document by remember {
        mutableStateOf<String?>(null)
    }

    LaunchedEffect(Unit) {
        document = api.getTermsAndConditionsMarkdown()
    }


    Box(
        modifier = Modifier
            .padding(24.px)
            .fillMaxSize(),
    ) {
        Column(
            modifier = Modifier.fillMaxSize(),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            document?.let { doc ->
                Div(
                    attrs = Modifier.toAttrs {
                        ref {
                            it.innerHTML = Marked.parse(doc)
                            onDispose { }
                        }
                    }
                )
            }
        }
    }
}
